import _snakeCase from "lodash/snakeCase";

export function fireWebsiteLeadEvent(formName: string, formId = _snakeCase(formName)) {
  if (process.env.NODE_ENV !== "production" || typeof window["gtag"] !== "function") {
    return;
  }

  window["gtag"]("event", "website_lead", {
    form_id: formId,
    form_name: formName,
  });
}
